module.exports = {
    'Init': require('./init'),
    'InsertResults': require('./insert-results'),    
    'Search': require('./search'),    
};